import { render, staticRenderFns } from "./colored-box.vue?vue&type=template&id=3f2faf0f&scoped=true&functional=true"
import script from "./colored-box.vue?vue&type=script&lang=js"
export * from "./colored-box.vue?vue&type=script&lang=js"
import style0 from "./colored-box.vue?vue&type=style&index=0&id=3f2faf0f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "3f2faf0f",
  null
  
)

export default component.exports